import { getStore } from '@/services/context';

import { BACKEND_VERSION_HEADER } from './constants';
import { setBackendVersion } from './services/slices';

export async function backendVersionInterceptor(response: Response) {
    const backendVersion = response.headers.get(BACKEND_VERSION_HEADER);

    if (backendVersion) {
        const store = await getStore();
        store.dispatch(setBackendVersion(backendVersion));
    }

    return response;
}
